import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import LoginLayout from "@/pages/Layout/LoginLayout.vue";

import Login from "@/pages/Login.vue";

import Common from "@/pages/Common.vue";
import TableList from "@/pages/TableList.vue";
import MayaiList from "@/pages/MayaiList";
import MayaiStatus from "@/pages/MayaiStatus";
import MayaiReports from "@/pages/MayaiReports";
import MayaiDailyReports from "@/pages/MayaiDailyReports";
import NgWord from "@/pages/NgWordPage.vue";
import MayaiDetails from "@/pages/MayaiDetails";
import MayaiCustomerList from "@/pages/MayaiCustomerList";
import MayaiCustomerDetails from "@/pages/MayaiCustomerDetails";
// import MayaiCustomerList from "@/pages/MayaiCustomerList"
import MayaiNumberDetails from "@/pages/MayaiNumberDetails";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    // redirect: "/dashboard",
    children: [
      {
        path: "/",
        name: "home",
        component: Common
      },
      {
        path: "common_page",
        name: "Common",
        component: Common
      },
      {
        path: "ng_word",
        name: "NGWord",
        component: NgWord
      },
      // {
      //   path: "dashboard",
      //   name: "Dashboard",
      //   component: Dashboard
      // },
      // {
      //   path: '/login',
      //   name: 'login',
      //   component: Login
      // },
      // {
      //   path: '/logout',
      //   name: 'logout',
      //   component: Login,
      //   redirect: '/login' },
      // {
      //   path: "user",
      //   name: "User Profile",
      //   component: UserProfile
      // },
      {
        path: "salesidol_table",
        name: "Salesidol Customers",
        component: TableList
      },
      // {
      //   path: "mayai_table",
      //   name: "Mayai Customers",
      //   component: MayaiList
      // },
      // {
      //   path: "mayai_customer_list",
      //   name: "Mayai Customer List",
      //   component: MayaiDetails
      // },
      {
        path: "mayai_customer_list",
        name: "Mayai Customer List",
        component: MayaiCustomerList
      },
      {
        path: "mayai_customer_list/:customerId",
        name: "Mayai Customer Details",
        component: MayaiCustomerDetails,
        props: true
      },
      {
        path: "update_mayai_status",
        name: "Mayai Status",
        component: MayaiStatus
      },
      {
        path: "mayai_reports",
        name: "Mayai Reports",
        component: MayaiReports
      },
      {
        path: "mayai_daily_reports",
        name: "Mayai Daily Reports",
        component: MayaiDailyReports
      },
      {
        path: "number_pool",
        name: "Number manager",
        component: MayaiNumberDetails
      },
    ]
  }
];

export default routes;
